export const QUALITY_ID_DUMMY_SHOW_ALL_ITEMS = -1;

export const DISABLED_OUTFIT_CHANGE_EXPLANATORY_TEXT = 'You can\'t change outfits at the moment.';